import React from 'react';
import { deleteRegistration, loadInspectorNotifications, logout, loadRegistrations, loadOrgs, loadUsers, addOrg, addOrgUser, loadInspections, createOrgAndUserByRequest} from "./../../actions/actions";
import { org_types, role_names } from './../../helpers/trans';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import Button  from '@material-ui/core/Button';
import { Redirect } from  "react-router-dom";
import Header from './../Header';
import Footer from './../Footer';
import Toolbar from '@material-ui/core/Toolbar';
import { Link } from 'react-router-dom';
import NotificationList from './../lists/NotificationList';

export class AdminPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            redirect:null,
            auth: false,
            user:{},
            hasError: false,
            value: 0,
            status: 'new',
            requests: [],
            orgs: [],
            inspections: [],
            users:[],
            requestsPending: false,
            checked: [1],
        }
    }

    handleToggle = value => () => {
        const {checked} = this.state;
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        this.setState({
            checked: newChecked,
        });
    }

    logout = () => {
        console.log('logout');
        this.props.logout();
        this.setState({auth:false, redirect: null, user:{}});
    }


    render() {
        if (this.state.auth == false) {
            return (<Redirect to="/login"/>)
        }
        
        return (
                <div>
                    <Header link={{title: this.state.user.org, to:'/admin/'}}/>
                    <Toolbar>
                        <Button component={Link} to="/admin/">Вернуться</Button>
                        <Button onClick={this.logout}>Выйти</Button></Toolbar>
                    <Paper>
                    <h2>Управление пользователями</h2>
                    <List>
                        {this.props.users.map(item => (
                            <ListItem key={item.id} dense button>
                                <ListItemText primary={`${item.email}`} />
                                <ListItemSecondaryAction>
                                    {item.org}|{item.roles.map(role => (role_names[role])).join(', ')}|{item.blocked ? 'Заблокирован' : ''} | {item.activated ? 'Активирован' : ''}
                                    <Button component={Link} to={`/manage-acc/${item.id}/`}>Редактировать</Button>
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}
                    </List>
                    </Paper>
                    <Footer />
                </div>);
    }

    componentWillMount(){
        let user = JSON.parse(localStorage.getItem('user'));
        if (user !== null && ('role' in user) && (Array.isArray(user.role)) && user.role.indexOf('ROLE_SUPER_ADMIN') > -1) {
            this.setState({auth :true, user: user});
            if (this.props.requests.length === 0){this.props.loadRegistrations(user.token);}
            if (this.props.users.length === 0){this.props.loadUsers(user.token);}
            if (this.props.orgs.length === 0) {this.props.loadOrgs(user.token);}
            if (this.props.inspections.length === 0){this.props.loadInspections(user.token);}
            if (this.props.notifications.length === 0) {this.props. loadInspectorNotifications(user.token);}
        }
    }

    componentWillReceiveProps(nextProps) {
        console.log('Props received');
        console.log(nextProps);

        this.setState(nextProps);
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // You can also log the error to an error reporting service
       console.log(error, info);
    }
}

AdminPage.propTypes = {
    orgs : PropTypes.array.isRequired,
    inspections: PropTypes.array.isRequired,
    users: PropTypes.array.isRequired,
    requests: PropTypes.array.isRequired,
    notifications: PropTypes.array.isRequired
}

AdminPage.defaultProps = {
    orgs: [],
    inspections: [],
    users: [],
    requests: [],
    notifications: []
}


function select(state, props) {
    const { requests, inspections, requestsPending, orgs, users} = state.admin;
    const { notifications } = state;
    console.log('SELECT');
    console.log(requests);
    console.log(users);
    console.log(inspections);
    console.log(orgs);
    return {
        requestsPending: requestsPending || false,
        requests: requests || [],
        inspections: inspections || [],
        orgs: orgs || [],
        users: users || [],
        notifications: (typeof notifications !== "undefined" && 'data' in notifications) ? notifications.data : [],
    };
}


function mapDispatch(dispatch) {
    return {
        loadInspectorNotifications: bindActionCreators( loadInspectorNotifications, dispatch),
        logout: bindActionCreators(logout, dispatch),
        loadRegistrations: bindActionCreators(loadRegistrations, dispatch),
        loadInspections: bindActionCreators(loadInspections, dispatch),
        loadOrgs: bindActionCreators(loadOrgs, dispatch),
        loadUsers: bindActionCreators(loadUsers, dispatch),
        addOrg: bindActionCreators(addOrg, dispatch),
        addOrgUser: bindActionCreators(addOrgUser, dispatch),
        createOrgAndUserByRequest: bindActionCreators(createOrgAndUserByRequest, dispatch),
        deleteRegistration: bindActionCreators(deleteRegistration, dispatch)
    };
}


export default connect(select, mapDispatch)(AdminPage);





// WEBPACK FOOTER //
// ./assets/src/js/components/pages/AdminUsers.jsx